import { useFormikContext } from 'formik'
import requests from 'service/api'
import AsyncSearchSelect from '../async-search-select'
import { asOptions, firstOption } from 'lib/asyncList'

export function SelectCompany2({ name, labelName, defaultChoice }) {
  const { values } = useFormikContext()
  const current = values?.[name] || defaultChoice
  const mapCompany = ({ id, name: label }) => ({ value: id, label })

  return (
    <AsyncSearchSelect
      label=""
      name={name}
      labelName={labelName}
      value={current}
      fetchSelected={(id) => firstOption(requests.company.get(id), mapCompany)}
      fetchOptions={(search) => asOptions(requests.company.list({ search, limit: 20 }), mapCompany)}
    />
  )
}
